/* eslint-disable max-classes-per-file */
import { RuleValidationMessage } from "~app/common/services/cqs/models/rule-validation-message";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { AtgardAnmalanTradslagDTO } from "./mbf-models";

export class AvverkningsanmalanRaskStatus {
    static readonly okand = 0;
    static readonly ny = 1;
    static readonly andrad = 2;
    static readonly ogiltig = 3;
}

export interface IAtgardNettoareal{
    atgardGuid: string;
    nettoareal: number;
    atgardstyp: string;
    avverkningsanmalanGodkantDatum?: Date | string;
    beteckning: string;
}

export class VKAvverkningsanmalanDTO {
    id: number;
    ansokan: boolean;
    avverkningFarStartaDatum?: Date | string;
    godkantDatum?: Date | string;
    giltigtTillDatum?: Date | string;
    avslagDatum?: Date | string;
    typ?: string;
    dispens: boolean;
    status: string;
    raskStatus: number;
    atgardsgeometri: string;
    atgardKanAvverkningsanmalas: boolean;
    delytorAvstandOgiltig: boolean;
    anmalanTradslag: AtgardAnmalanTradslagDTO[];
    validationMessages: RuleValidationMessage[];
}

export class Avverkningsanmalan extends VKAvverkningsanmalanDTO {

    get isAvverkningsanmalanGjord(): boolean {
        return ObjectUtils.hasValue(this.godkantDatum);
    }

    get hasRaskStatusOgiltig(): boolean {
        return this.raskStatus === AvverkningsanmalanRaskStatus.ogiltig;
    }

    get hasRaskStatusAndrad(): boolean {
        return this.raskStatus === AvverkningsanmalanRaskStatus.andrad;
    }

    get hasRaskStatusNy(): boolean {
        return this.raskStatus === AvverkningsanmalanRaskStatus.ny;
    }

    constructor(avv: VKAvverkningsanmalanDTO) {
        super();
        this.id = avv?.id;
        this.ansokan = avv?.ansokan;
        this.avverkningFarStartaDatum = avv?.avverkningFarStartaDatum;
        this.godkantDatum = avv?.godkantDatum;
        this.giltigtTillDatum = avv?.giltigtTillDatum;
        this.avslagDatum = avv?.avslagDatum;
        this.typ = avv?.typ;
        this.dispens = avv?.dispens;
        this.status = avv?.status;
        this.atgardKanAvverkningsanmalas = avv?.atgardKanAvverkningsanmalas;
        this.delytorAvstandOgiltig = avv?.delytorAvstandOgiltig;
        this.anmalanTradslag = avv?.anmalanTradslag;
        this.raskStatus = avv?.raskStatus;
        this.atgardsgeometri = avv?.atgardsgeometri;
        this.validationMessages = avv?.validationMessages;
    }
}
